import React from "react";
import MembershipSummaryBanner from './MembershipSummaryBanner';

const WizardStep3 = ({ formData, itemsList }) => {
  if (!formData) return null;


function MembershipItemsReviewList({ itemsList, formData}) {
  if (!Array.isArray(itemsList) || !itemsList.length)
    return <div className="text-muted fst-italic">No items defined.</div>;

  return (
    <div className="membership-items-review">
      {itemsList.map((item, i) => (
        <div key={i} className="membership-item-entry border p-3 mb-3 rounded bg-light">

          {/* --- Header --- */}
          <div className="col-12" style={{ paddingTop: "15px" }}>
            <h5>Product or service that can be redeemed:</h5>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <label className="fw-semibold d-block">Type</label>
              <div>{item.type || "—"}</div>
            </div>

            <div className="col-md-8">
              <label className="fw-semibold d-block">Service/Product Name</label>
              <div>{item.name || item.itemLabel || "—"}</div>
            </div>
          </div>

          {/* --- Pricing and Redemption --- */}
          <div className="col-12" style={{ paddingTop: "15px" }}>
            <h5>Pricing & Redemption — Any extra charge when redeeming, and the cash value that can be applied to something else if not redeemed:</h5>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              <label className="fw-semibold d-block">Additional Charge When Redeemed</label>
              <div>
                {item.priceOverride
                  ? `$${item.unitPrice ?? 0}`
                  : "Use original price"}
              </div>
            </div>

            <div className="col-md-4">
              <label className="fw-semibold d-block">
                Cash Value (can be applied to something else)
              </label>
              <div>{item.cashValue ? `$${item.cashValue}` : "—"}</div>
            </div>

          </div>

          {/* --- Credits / Period-based details --- */}
          {[1, 2].includes(formData.membershipType) && (
            <>
              <div className="col-12" style={{ paddingTop: "15px" }}>
                {formData?.membershipItemsNeverExpire ? (
                  <h5>
                    Credits — Quantity per period & rollover.
                  </h5>
                ) : (
                  <h5>
                    Credits — Quantity per period, rollover, and expiry.
                  </h5>
                )}
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="fw-semibold d-block">Quantity / Period</label>
                  <div>{item.perPeriodQtyLimit ?? "—"}</div>
                </div>

                <div className="col-md-4">
                  <label className="fw-semibold d-block">Rollover Quantity</label>
                  <div>{item.rollOverQtyLimit ?? "—"}</div>
                </div>

                {!formData?.membershipItemsNeverExpire && (
                  <div className="col-md-4">
                    <label className="fw-semibold d-block">
                      Rollover Time Limit ({formData.membershipPeriodUnit})
                    </label>
                    <div>{item.rollOverTimeLimit ?? "—"}</div>
                  </div>
                )}
              </div>
            </>
          )}

            {[3].includes(formData.membershipType) && (
              <>  
              <div className="col-12" style={{paddingTop:'30px'}}>
                  <h5 >Count As — If this product or service counts as more than one credit when redeemed, count as (if zero or blank, defaults to 1):</h5>
              </div>

              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="fw-semibold d-block">Count As</label>
                  <div>{item.countsAs ?? "—"}</div>
                </div>
              </div>
              </>
            )}

        </div>
      ))}
    </div>
  );
}




  return (
    <div>
      <h4 className="mb-4">Review Membership Summary</h4>

      <MembershipSummaryBanner formData={formData} />
      <MembershipItemsReviewList itemsList={itemsList} formData={formData} />

      {/* {formData.items && formData.items.length > 0 && (
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Included Items</h5>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Cash Value</th>
                  <th>Counts As</th>
                  <th>Rollover Quantity</th>
                  <th>Rollover Time Limit</th>
                </tr>
              </thead>
              <tbody>
                {formData.items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.itemName}</td>
                    <td>{item.perPeriodQtyLimit}</td>
                    <td>{item.cashValue || 0}</td>
                    <td>{item.countsAs || 1}</td>
                    <td>{item.rollOverQtyLimit}</td>
                    <td>{formData.membershipItemsNeverExpire ? "Never" : item.rollOverTimeLimit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )} */}

    </div>
  );
};

export default WizardStep3;
